export function validZipcode(zipcode) {
  return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipcode);
}
